import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Flex, Box, Image, Text, useDisclosure } from '@chakra-ui/react';
import { MdToken } from 'react-icons/md';
import { SiSpeedtest } from 'react-icons/si';
import { FaOilCan } from 'react-icons/fa';
import { MdLeaderboard } from "react-icons/md";
import { FaBitbucket } from "react-icons/fa";
import { useLocation, useHistory } from "react-router-dom";
import { MdNetworkLocked } from "react-icons/md";
import { TiInfo } from "react-icons/ti";

// Components
import InfoModal from './modals/Info.js';
import ProgressModal from './modals/Progress.js';
import DonationsModal from './modals/Donations.js';
import MarketModal from './modals/Market.js';
import { models } from '../../components/Settings/Models.js';

const parseNum = (n) => {
  if(0 <= n && n < 10000){
    return n;
  } else if(10000 <= n && n < 1000000) {
    return (Math.floor(n / 1000)) + 'K';
  } else if(1000000 <= n) {
    return (Math.floor(n / 1000000)) + 'M';
  } 
};

const Navbar = ({ tokens, setTokens, pagePlay, setPagePlay, sessionTokens, isClaim, activeModel, setActiveModel, setActiveBuyPopup }) => {
  
  const { isOpen: InfoIsOpen, onOpen: InfoOnOpen, onClose: InfoOnClose } = useDisclosure();
  const { isOpen: ProgressIsOpen, onOpen: ProgressOnOpen, onClose: ProgressOnClose } = useDisclosure();
  const { isOpen: MarketIsOpen, onOpen: MarketOnOpen, onClose: MarketOnClose } = useDisclosure();
  const { isOpen: DonationsIsOpen, onOpen: DonationsOnOpen, onClose: DonationsOnClose } = useDisclosure();

  const location = useLocation();
  const history = useHistory();

  const handleExit = () => {
    setPagePlay(false);
    history.push('/');
  };

  useEffect(() => {
    if(!localStorage.getItem('newUser') && !InfoIsOpen){
      InfoOnOpen();
    }
  }, []);

  const handleActiveModel = (index) => {
    setActiveModel(index);
    localStorage.setItem('activeModel', index);

    const checkModel = localStorage.getItem(`unlockedModel_${index}`);
    if(models[index].price > 0 && !checkModel){
      setActiveBuyPopup(true);
    } else {
      setActiveBuyPopup(false);
    }
  };

  return (
    <Flex gap="10px" 
      position="absolute"
      w="100%" 
      zIndex="9" 
      mt="110px"
      p="0px 20px 0px 20px" 
      top="0" 
      justifyContent="space-between"
      className="navbar"
      h="170px" 
      w="100%">
      <Box>
        { location.pathname === "/" ? (
        <>
          <Box className="neon-icon" m="10px">
            <MdLeaderboard 
              color="#fff9ea" 
              onClick={ProgressOnOpen} 
              style={{transform: 'rotate(-20deg)', margin: '9px 0px 0px 9px'}} 
              fontSize="28px" 
               />
          </Box>

          {/*<Box className="neon-icon" m="10px">
            <FaBitbucket 
              color="#fff9ea"
              onClick={MarketOnOpen} 
              style={{transform: 'rotate(-20deg)', margin: '14px 0px 0px 13px'}} 
              fontSize="25px" />
          </Box>*/}

          <Box className="neon-icon" m="10px">
            <FaOilCan 
              color="#fff9ea" 
              onClick={DonationsOnOpen} 
              style={{transform: 'rotate(-20deg)', margin: '9px 0px 0px 9px'}} 
              fontSize="32px" />
          </Box>

          <Box className="neon-icon" m="10px">
            <TiInfo 
              color="#fff9ea" 
              onClick={InfoOnOpen}
              style={{transform: 'rotate(-20deg)', margin: '10px 0px 0px 10px'}} 
              fontSize="28px" />
          </Box>
        </>
        ) : (
          <Text fontSize="28px" mt="14px" onClick={handleExit} className={ isClaim ? 'hidden' : '' }>EXIT</Text>
        )}

      </Box>

      <Box w="172px" textAlign="right">
      	<Flex gap="10px" justify="end" className={ isClaim ? 'hidden' : '' }>
        		<Text variant="title-lg" mt="12px" color="#dd1650" fontWeight="400" fontSize="30px">
              { pagePlay === true ? sessionTokens  : parseNum(tokens) }
            </Text>
        		<Box className="opacityAnim"><MdToken color="#dd1650" fontSize="64px" /></Box>
      	</Flex>

        { location.pathname === "/" && (
          <Box float="right" mr="-20px" mt="30px">
            { models && models.map((item, index) => { 
              const checkModel = localStorage.getItem(`unlockedModel_${index}`);
              
              return (
                <Box position="relative" 
                  borderBottom={ activeModel === index ? '2px solid #98183c' : '2px solid transparent' }>
                  { index !== 0 && !checkModel && (
                    <Box position="absolute" 
                      transform="rotateY(180deg)" 
                      bottom="-3px"
                      left="-4px">
                      <MdNetworkLocked color="#e9d8dd" fontSize="24px" />
                    </Box>
                  )}
                  <Box key={index} overflow="hidden" boxShadow="2px 8px 15px #b4184480">
                    <Image 
                      src={item.src}
                      w="100px" 
                      h="60px" 
                      objectPosition="center" 
                      objectFit="cover" 
                      onClick={() => handleActiveModel(index)}
                      opacity={index !== 0 && !checkModel ? '0.3' : '1'} />
                  </Box>

                  { activeModel === index && (
                    <Box
                      w="110%"
                      top="0"
                      p="0 17px 0 0"
                      left="-100%"
                      textAlign="right"
                      position="absolute">
                      <Box textAlign="right">
                        <Text variant="text-sm">{item?.name}</Text>
                        <Text variant="text-sm">
                          <span style={{ color: 'rgb(221, 22, 80)'}}>{item?.maxSpeed}</span> - ly
                        </Text>
                        <Text variant="text-sm">
                          <span style={{ color: 'rgb(221, 22, 80)'}}>1</span> - 
                          level</Text>
                      </Box>
                    </Box>
                  )}
                </Box>
            )})}
          </Box>
        )}
      	
      </Box>

      <ProgressModal 
        isOpen={ProgressIsOpen}
        onOpen={ProgressOnOpen}
        onClose={ProgressOnClose}
      />

      <DonationsModal 
        isOpen={DonationsIsOpen}
        onOpen={DonationsOnOpen}
        onClose={DonationsOnClose}
      />

      <InfoModal 
        isOpen={InfoIsOpen}
        onOpen={InfoOnOpen}
        onClose={InfoOnClose}
      />

      <MarketModal
        tokens={tokens} 
        setTokens={setTokens}
        isOpen={MarketIsOpen}
        onOpen={MarketOnOpen}
        onClose={MarketOnClose}
      />
      
    </Flex>
  );
};

export default Navbar;